import { buildBreadcrumbs } from './build-breadcrumbs';
import { BreadcrumbSegment } from './types';

export const breadcrumbSegments = {
	services: { label: 'Services', href: '/services' },
	blog: { label: 'Blog', href: '/blog' },
	caseStudies: { label: 'Case Studies', href: '/case-studies' },
	industries: { label: 'Industries', href: '/industries' },
	aboutUs: { label: 'About Us', href: '/about-us' },
	partnership: { label: 'Referral Program', href: '/partnership' },
	privacyPolicy: { label: 'Privacy Policy', href: '/privacy-policy' },
	brandBook: { label: 'Brand Book', href: '/resources/brand-book' }
} satisfies Record<string, BreadcrumbSegment>;

export const breadcrumbTrails = {
	servicesLobby: () => buildBreadcrumbs([breadcrumbSegments.services]),
	servicePage: (title: string) => buildBreadcrumbs([breadcrumbSegments.services, { label: title }]),
	blogLobby: () => buildBreadcrumbs([breadcrumbSegments.blog]),
	blogPost: (title: string) => buildBreadcrumbs([breadcrumbSegments.blog, { label: title }]),
	blogAuthor: (name: string, fromPost?: { label: string; href: string }) =>
		buildBreadcrumbs([
			breadcrumbSegments.blog,
			...(fromPost ? [{ ...fromPost, truncate: true }] : []),
			{ label: name }
		]),
	caseStudiesLobby: () => buildBreadcrumbs([breadcrumbSegments.caseStudies]),
	caseStudy: (title: string) =>
		buildBreadcrumbs([breadcrumbSegments.caseStudies, { label: title }]),
	industriesLobby: () => buildBreadcrumbs([breadcrumbSegments.industries]),
	industryPage: (title: string) =>
		buildBreadcrumbs([breadcrumbSegments.industries, { label: title }]),
	aboutUs: () => buildBreadcrumbs([breadcrumbSegments.aboutUs]),
	partnership: () => buildBreadcrumbs([breadcrumbSegments.partnership]),
	privacyPolicy: () => buildBreadcrumbs([breadcrumbSegments.privacyPolicy]),
	brandBook: () => buildBreadcrumbs([breadcrumbSegments.brandBook])
};
